import routes from '../config/routes';

export default function (path: string) {
    return routes.find((route) => route.path.startsWith('/' + path.split('/')[1]));
}
